import { Pipe, PipeTransform } from "@angular/core";
import { FullClient, FullClientType } from "@models/full-client.model";

@Pipe({
	name: "fullClientName",
	standalone: true,
})
export class FullClientNamePipe implements PipeTransform {
	transform(client: FullClient): string | null {
		return (
			(client?.type === FullClientType.REMPLACANT ? client.pseudo || client.remplacant.nom : client?.pseudo) ||
			null
		);
	}
}
